import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const infoButton: ThemeUICSSObject = {
  '&.iconButton': {
    cursor: 'pointer',
    height: '0px',
    minHeight: '16px',
    color: 'palette.gray.800',
    p: spacing(0),
    width: 'auto',
    minWidth: 'auto',

    '&.isToggled': {
      cursor: 'pointer',
      minHeight: '0px',
      color: 'palette.primary.main',
    },
  },
};

export default infoButton;
